import {mergeConfig} from '../../configStore'
import {field} from '../field'
import type {MessageField, FieldReturn} from '../../types'

export const message = (
  _message: string,
  props?: MessageField,
  mergeProps?: Partial<MessageField>,
): FieldReturn => {
  const defaultProps: Partial<MessageField> = {
    name: 'message',
    options: {
      message: _message,
    },
  }

  return field('message', mergeConfig('message', props, mergeProps, defaultProps))
}
